import React, { useEffect, useMemo, useState } from 'react'

type Props = {
  visible: boolean
  durationMs?: number
}

const COLORS = ['#22c55e', '#3b82f6', '#eab308', '#f97316', '#ec4899', '#a855f7', '#06b6d4', '#f43f5e']

export default function GiftCelebration({ visible, durationMs = 2400 }: Props) {
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (!visible) { setShow(false); return }
    setShow(true)
    const t = setTimeout(() => setShow(false), durationMs)
    return () => clearTimeout(t)
  }, [visible, durationMs])

  const pieces = useMemo(() => {
    if (!show) return []
    const n = 36
    return Array.from({ length: n }).map((_, i) => {
      const left = Math.random() * 100
      const delay = Math.random() * 0.35
      const dur = 1.6 + Math.random() * 1.4
      const size = 6 + Math.random() * 8
      const rotate = Math.floor(Math.random() * 360)
      const sway = (Math.random() * 2 - 1) * 60
      const color = COLORS[i % COLORS.length]
      return { i, left, delay, dur, size, rotate, sway, color }
    })
  }, [show])

  if (!show) return null

  return (
    <div className="fixed inset-0 pointer-events-none z-[60] overflow-hidden">
      <style>{`
        @keyframes gift_confetti_rise {
          0% { transform: translate3d(0, 20px, 0) rotate(0deg); opacity: 0; }
          10% { opacity: 1; }
          100% { transform: translate3d(var(--sway, 0px), -115vh, 0) rotate(720deg); opacity: 0; }
        }
      `}</style>
      {pieces.map((p) => (
        <span
          key={p.i}
          aria-hidden="true"
          className="absolute bottom-0 rounded-[2px]"
          style={{
            left: `${p.left}%`,
            width: `${p.size}px`,
            height: `${Math.max(6, p.size * 0.6)}px`,
            background: p.color,
            transform: `translate3d(0, 20px, 0) rotate(${p.rotate}deg)`,
            animation: `gift_confetti_rise ${p.dur}s cubic-bezier(.2,.8,.2,1) ${p.delay}s forwards`,
            ['--sway' as any]: `${p.sway}px`,
            filter: 'drop-shadow(0 6px 10px rgba(0,0,0,0.35))',
          }}
        />
      ))}
    </div>
  )
}
